"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var ac_ui_1 = require("@aperza/ac-ui");
var react_router_dom_1 = require("react-router-dom");
exports.AcPageDataList = react_1.default.forwardRef(function (props, ref) {
    var query = props.query, columns = props.columns, pathToPage = props.pathToPage, page = props.page, onChangePage = props.onChangePage, size = props.size, onChangeSize = props.onChangeSize, sorts = props.sorts, onChangeSorts = props.onChangeSorts, filter = props.filter, highlight = props.highlight, onRowClick = props.onRowClick, onRowExpand = props.onRowExpand, activeData = props.activeData, whenNoData = props.whenNoData, whenLoading = props.whenLoading, grid = props.grid, refetchTimestamp = props.refetchTimestamp, toolbar = props.toolbar, filterBar = props.filterBar, onDataChange = props.onDataChange, withDownloadButtons = props.withDownloadButtons, onDownloadClick = props.onDownloadClick, onUploadClick = props.onUploadClick, hidePagination = props.hidePagination;
    var _a = react_1.useState([]), selectedData = _a[0], setSelectedData = _a[1];
    var _b = react_1.useState(false), previewOpened = _b[0], setPreviewOpened = _b[1];
    var location = react_router_dom_1.useLocation();
    var previewFaxDocumentId = react_router_dom_1.useParams().previewFaxDocumentId;
    var setPage = function (currentPage) {
        if (onChangePage)
            onChangePage(currentPage);
    };
    var setSize = function (currentSize) {
        if (onChangeSize)
            onChangeSize(currentSize);
    };
    var setSorts = function (currentSorts) {
        if (onChangeSorts)
            onChangeSorts(currentSorts);
    };
    var _c = client_1.useQuery(query, {
        variables: __assign({ page: page,
            size: size,
            sorts: sorts }, filter),
    }), loading = _c.loading, data = _c.data, refetch = _c.refetch, client = _c.client, networkStatus = _c.networkStatus;
    var refetchPage = function () {
        return refetch(__assign({ page: page,
            size: size,
            sorts: sorts }, filter));
    };
    react_1.useEffect(function () {
        if (previewFaxDocumentId) {
            var previewRowElement = document.getElementById("ac-table-row-" + previewFaxDocumentId);
            if (previewRowElement) {
                if (!previewRowElement.classList.contains('table-active')) {
                    // make row active
                    previewRowElement.click();
                }
                else {
                    // needs to be put in an else so that both clicks don't happen on the same render
                    var urlSearchParams = new URLSearchParams(location.search);
                    if (urlSearchParams.has('open') && !previewOpened) {
                        //open preview modal
                        previewRowElement.click();
                        setPreviewOpened(true);
                    }
                }
            }
        }
    });
    var refetchFirstPage = function () {
        if (page === 1) {
            return refetchPage();
        }
        setPage(1);
        return Promise.resolve();
    };
    react_1.useEffect(function () {
        refetchPage();
    }, [page, size, json_stable_stringify_1.default(filter), json_stable_stringify_1.default(sorts)]);
    react_1.useImperativeHandle(ref, function () { return ({
        refresh: function () {
            if (!loading)
                refetchPage();
        },
    }); });
    /**
     * Filter change. Set page = 1
     */
    // useEffect(() => {
    //   refetchFirstPage()?.then();
    // }, [filter]);
    /**
     * To force refresh the page, set location.state.refetch = true
     * TODO check sending location.state.refetch = true twice will not refresh (no state change)
     */
    react_1.useEffect(function () {
        if (location.state && location.state.refetch) {
            refetchFirstPage();
        }
    }, [location.state]);
    react_1.useEffect(function () {
        if (refetchTimestamp > 0) {
            refetchFirstPage();
        }
    }, [refetchTimestamp]);
    var getPageData = function () {
        return util_1.ObjectUtil.get(data, pathToPage);
    };
    var getPageContent = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.content;
        }
        return [];
    };
    var getPageNumber = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.page;
        }
        return 1;
    };
    var getPageSize = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.size;
        }
        return 10;
    };
    var getTotalElements = function () {
        var pageData = getPageData();
        if (pageData) {
            return pageData.totalElements;
        }
        return 0;
    };
    var onSort = function (columnId, direction) {
        setSorts([[columnId, direction]]);
    };
    var onSelectRows = function (data) {
        setSelectedData(data);
    };
    var onClickPage = function (_page) {
        setPage(_page);
    };
    var onSelectPageSize = function (_pageSize) {
        setSize(_pageSize);
        setPage(1); // reset to first page after the pagesize is set
    };
    var isLoading = function () {
        return loading || networkStatus === client_1.NetworkStatus.refetch;
    };
    react_1.useEffect(function () {
        if (onDataChange) {
            var pageData = getPageData();
            onDataChange(pageData);
        }
    }, [data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "d-flex flex-row mb-6 align-items-center" },
            !hidePagination && (react_1.default.createElement(ac_ui_1.AcPaginationInfo, { page: page, size: size, totalElements: getTotalElements() })),
            react_1.default.createElement("div", { className: "ml-auto d-flex flex-row" },
                toolbar,
                !hidePagination && onChangeSize && (react_1.default.createElement(ac_ui_1.AcTablePageSizeDropdown, { pageSize: size, updatePageSize: onSelectPageSize })),
                filterBar && react_1.default.createElement("div", { className: "ml-3" }, filterBar))),
        react_1.default.createElement(ac_ui_1.AcDataList, { data: getPageContent(), activeData: activeData, functionContext: {
                page: page,
                size: size,
                filter: filter,
                pageData: getPageData(),
                client: client,
                refetch: refetch,
            }, loading: loading, columns: columns, grid: grid, onSort: onSort, sorts: sorts, onSelectRows: onSelectRows, highlight: highlight, page: getPageNumber(), size: size !== null && size !== void 0 ? size : getPageSize(), onSelectPageSize: onSelectPageSize, totalElements: getTotalElements(), onClickPage: onClickPage, onRowClick: onRowClick, onRowExpand: onRowExpand, whenLoading: whenLoading, whenNoData: whenNoData !== null && whenNoData !== void 0 ? whenNoData : undefined, hidePagination: hidePagination })));
});
exports.AcPageDataList.displayName = 'AcPageDataList';
//# sourceMappingURL=AcPageDataList.js.map